import ActionTypes from 'redux/ActionTypes';

const initialState = {
	msg: '',
	close: true,
	error: true,
	name: {
		ModalInfo: false,
		ModalConfirm: false,
		ModalPrize: false,
		ModalMessage: false,
		ModalShare: false,
	},
};

const modal = (state = initialState, { type, payload }) => {
	switch (type) {
		case ActionTypes.TOGGLE_MODAL:
			return {
				...state,
				name: { ...state.name, [payload.modalName]: payload.modalState },
			};
		case ActionTypes.SET_MSG:
			return { ...state, msg: payload };
		case ActionTypes.SHOW_CLOSE:
			return { ...state, close: payload };
		case ActionTypes.TOGGLE_ERROR:
			return { ...state, error: payload };
		default:
			return state;
	}
};

export default modal;
